import React from 'react'

const AdminComponents = () => {
  return (
    <div>AdminComponents</div>
  )
}

export default AdminComponents